/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { GenericDialogModule } from 'src/app/common/generic-dialog/generic-dialog.module';
import { MaterialModule } from 'src/app/common/material/material-module';
import { SharedUIMaterialModule } from '../../shared/ui/material/shared-ui-material.module';
import { AttachedFilesService } from './attached-files.service';
import { AttachedImageThumbnailComponent } from './components/attached-file-viewer/attached-file-viewer.component';
import { AttachedImagesToolBarComponent } from './components/attached-images-tool-bar/attached-images-tool-bar.component';
import { AttachedImagesComponent } from './components/attached-images/attached-images.component';
import { ImageListViewComponent } from './components/image-list-view/image-list-view.component';
import { SelectedImageViewComponent } from './components/selected-image-view/selected-image-view.component';
import { PreviewCarouselComponent } from './components/preview-carousel/preview-carousel.component';
import { FancyFirebaseFileAttachApiBuilder } from 'src/app/services/fancy-firebase-api-builder/fancy-firebase-file-attach-api-builder-service';

@NgModule({
	declarations: [
		AttachedImagesToolBarComponent,
		AttachedImagesComponent,
		ImageListViewComponent,
		SelectedImageViewComponent,
		AttachedImageThumbnailComponent,
		PreviewCarouselComponent,
	],
	imports: [CommonModule, MaterialModule, ReactiveFormsModule, SharedUIMaterialModule, GenericDialogModule],
	exports: [
		AttachedImagesToolBarComponent,
		AttachedImagesComponent,
		ImageListViewComponent,
		SelectedImageViewComponent,
		AttachedImageThumbnailComponent,
		PreviewCarouselComponent,
	],
	providers: [AttachedFilesService, FancyFirebaseFileAttachApiBuilder],
})
export class FileAttachModule {}
